module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"isVipSwitchLabel":"Ceci est un lieu VIP ?","labelPoints":"Points"},"en":{"isVipSwitchLabel":"is this a VIP POI?","labelPoints":"Points"}}')
  delete Component.options._Ctor
}
